import { parseDateOnly } from '@/helpers/dateHelper';
import { getRequestStatus } from '@/helpers/requestStatusHelper';
import { RequestStatus } from '@/pages/team/teamMember/requests/RequestsTable.types';
import { useGetLeaveType } from '@/services/leaveManagement/LeaveTypesProvider';
import { useUpcomingLeaveRequests } from '@/services/leaveManagement/useUpcomingLeaveRequests';
import { useMemo } from 'react';

export type LeaveRequestListItem = {
  id: string;
  title: string;
  startDate: Date;
  endDate: Date;
  status: RequestStatus;
};

const VISIBLE_STATUSES: RequestStatus[] = [RequestStatus.Pending, RequestStatus.Approved];

export const useUpcomingLeaveListItems = (employeeId: string) => {
  const { requests, refetch } = useUpcomingLeaveRequests(employeeId);
  const getLeaveType = useGetLeaveType();

  const items = useMemo<LeaveRequestListItem[]>(
    () =>
      requests.flatMap(request => {
        if (!request) return [];

        const status = getRequestStatus(request.requestState);
        if (!status || !VISIBLE_STATUSES.includes(status)) return [];

        return [
          {
            id: request.id,
            title: getLeaveType(request.leaveTypeId)?.properties.displayName ?? '',
            startDate: parseDateOnly(request.start),
            endDate: parseDateOnly(request.end),
            status
          }
        ];
      }),
    [requests, getLeaveType]
  );

  return { items, refetch };
};
